import React from 'react'

export const About = () => {
  return (
    <div>
        <h2>ABOUT</h2>
        <p>
            Hey!! So this is a <strong>Todo Manager</strong> Built on React!!
            <br></br>And yup this is my first Web App!!
            Give it a TRY!!
        </p>
    </div>
  )
}
